__webpack_require__.p = "/wp-content/themes/independent-lens/dist/js/";